export default "__VITE_ASSET__DH34U$yj__"